// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__6ZWdA","dark":"NavBar_dark__yn9kA"};